import { TFileFormValue } from 'common/types';
import {
    IBasicFileFragment,
    ICreateOfferInput,
    IFileFragment,
} from 'graphql/types';
import {
    TOfferEventDateFormInput,
    TOfferEventFormValues,
    TOfferFormValues,
} from 'offer/types';

type TValues = Omit<ICreateOfferInput, 'groupConditions'> &
    TOfferEventFormValues & {
        image?: IFileFragment | IBasicFileFragment | TFileFormValue | null;
        overviewImage?:
            | IFileFragment
            | IBasicFileFragment
            | TFileFormValue
            | null;
        isServiceProviderWebinar?: boolean;
    };

/**
 * Separates offer and offer event values into an object
 */
export function getOfferFormValues(
    values: TValues,
    hasServiceProvider?: boolean
) {
    return Object.keys(values).reduce(
        (acc, field) => {
            // Removes image with file from the eventual form values
            if (field === 'image' || field === 'overviewImage') return acc;

            const offerFields = [
                'title',
                'description',
                'imageId',
                'titleColor',
                'overviewImageId',
                'hasDetailPage',
                'extraCategories',
                'groupConditions',
            ];

            if (offerFields.includes(field)) {
                return {
                    ...acc,
                    offer: { ...acc.offer, [field]: values[field] },
                };
            }

            let newValue = values[field];

            if (field === 'dates' && !!newValue) {
                newValue = (newValue as TOfferEventDateFormInput[]).map(
                    (offerEventDate) => {
                        const webinarLink = offerEventDate.webinarLink
                            ? `https://${offerEventDate.webinarLink}`
                            : '';

                        const location = offerEventDate.location;
                        const locationId = location ? location?.id : null;
                        const locationString = location?.title || '';

                        // When organisation doesn't have service provider, we always set isServiceProviderWebinar to false
                        const isServiceProviderWebinar = hasServiceProvider
                            ? offerEventDate.isServiceProviderWebinar
                            : false;

                        return {
                            id: offerEventDate.id,
                            startDate: offerEventDate.startDate,
                            endDate: offerEventDate.endDate,
                            webinarLink,
                            locationId,
                            locationString,
                            isServiceProviderWebinar,
                            trainers: offerEventDate.trainers,
                        };
                    }
                );
            }

            return {
                ...acc,
                event: { ...acc.event, [field]: newValue },
            };
        },
        { offer: {}, event: {} }
    ) as TOfferFormValues;
}
